export default "__VITE_ASSET__oFaQ$mYV__"